import React from 'react'
import {
    BackButton,
    Bloc,
    BlocImportDocument,
    BlocIntField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
    Title,
} from '../ImportAll'

export default function Vue19() {
    return (
        <div>
            <Header
                title="Vous possédez déjà un crédit ou une offre de banque ?"
                subTitle="Envoyer un scan de votre offre"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={100} time={1} />
            </div>

            <div className="Container">
                <Bloc
                    key="key5"
                    selectable
                    linked_data_id="prj_type"
                    linked_data_value="LOGEMENT_ANCIEN"
                    nbcolumn={2}
                    height={185}
                    gauche
                    imageTextStyle
                    logourl="svg/ancien.svg"
                    text1="Achat d’un"
                    text2="logement ancien"
                />
                <Bloc
                    key="key6"
                    selectable
                    linked_data_id="prj_type"
                    linked_data_value="LOGEMENT_NEUF"
                    nbcolumn={2}
                    height={185}
                    droit
                    imageTextStyle
                    logourl="png/cred_loc.png"
                    text1="Achat d’un"
                    text2="logement neuf"
                />
                <Bloc
                    key="key7"
                    selectable
                    linked_data_id="prj_type"
                    linked_data_value="TERRAIN_ET_CONSTRUCTION"
                    nbcolumn={2}
                    height={185}
                    gauche
                    imageTextStyle
                    logourl="svg/rp.svg"
                    text1="Achat d’un"
                    text2="terrain et / ou construction"
                />
                <Bloc
                    key="key8"
                    selectable
                    linked_data_id="prj_type"
                    linked_data_value="RENEGOCIATION"
                    nbcolumn={2}
                    height={185}
                    droit
                    imageTextStyle
                    logourl="svg/renego.svg"
                    text1="Prêt immobilier"
                    text2="renégociation "
                />
                <Bloc
                    key="key9"
                    selectable
                    linked_data_id="prj_type"
                    linked_data_value="TRAVAUX"
                    nbcolumn={2}
                    height={185}
                    gauche
                    imageTextStyle
                    logourl="png/cred_travaux.png"
                    text1="Logement ancien"
                    text2="travaux"
                />
                <Bloc
                    key="key10"
                    selectable
                    linked_data_id="prj_type"
                    linked_data_value="ACHAT_SCPI"
                    nbcolumn={2}
                    height={185}
                    droit
                    imageTextStyle
                    logourl="svg/scpi.svg"
                    text1="Achat de"
                    text2="parts SCPI"
                />

                <Title maintitle="Usage de votre projet" />

                <Bloc
                    key="key11"
                    selectable
                    linked_data_id="prj_usage"
                    linked_data_value="RES_PRINCIPALE"
                    nbcolumn={3}
                    height={193}
                    gauche
                    imageTextStyle
                    logourl="png/cred_rp.png"
                    text1="Résidence"
                    text2="principale"
                />
                <Bloc
                    key="key12"
                    selectable
                    linked_data_id="prj_usage"
                    linked_data_value="LOCATIF"
                    nbcolumn={3}
                    height={193}
                    milieu
                    imageTextStyle
                    logourl="svg/locatif.svg"
                    text1="Investissement"
                    text2="locatif"
                />
                <Bloc
                    key="key13"
                    selectable
                    linked_data_id="prj_usage"
                    linked_data_value="RES_SECONDAIRE"
                    nbcolumn={3}
                    height={193}
                    droit
                    imageTextStyle
                    logourl="svg/res_secondaire.svg"
                    text1="Résidence"
                    text2="secondaire"
                />

                <BlocIntField
                    key="key33"
                    nbcolumn={1}
                    linked_data_id="prj_montant_achat"
                    symbole=" €"
                    label="Prix d’achat"
                    placeholder="Ex : 10 000 €"
                    infobulle="Indiquez ici le prix TTC sauf si la TVA n’est pas à votre charge. Dans ce dernier car, veuillez indiquer le prix HT et ajuster manuellement les frais de notaire."
                    limit={1000000000}
                    messageErreur="Le montant du projet est trop élevé."
                />
                <BlocIntField
                    key="key114"
                    nbcolumn={1}
                    linked_data_id="finance_apport"
                    symbole=" €"
                    label="Montant de l’apport"
                    placeholder="Ex : 42 000 €"
                />

                <Title maintitle="Documents" />
                <BlocImportDocument key="key252" />
            </div>
            <Conditionnal linked_data_id="prj_type" isNotEmpty>
                <Conditionnal linked_data_id="prj_usage" isNotEmpty>
                    <Conditionnal linked_data_id="files" isNotEmpty>
                        <Conditionnal
                            linked_data_id="tech_nb_document_pour_comparer_offre"
                            isNotEmpty
                        >
                            <div className="SubmitButtonContainer">
                                {' '}
                                <Button
                                    text="Envoyez la demande"
                                    ComparerOffre
                                    targetView={20}
                                />{' '}
                            </div>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>
        </div>
    )
}
